/*
 * Display-only currency converter.
 *
 * The store's payment gateway (Razorpay) can only charge in the shop currency,
 * so Shopify Markets keeps every country on INR. This script shows prices in the
 * visitor's selected country's currency using daily exchange rates. Checkout is
 * still charged in the shop currency.
 */
(function () {
  const config = window.currencyConverterConfig;
  if (!config) return;

  const COUNTRY_CURRENCY = {
    AD: 'EUR', AE: 'AED', AF: 'AFN', AG: 'XCD', AI: 'XCD', AL: 'ALL', AM: 'AMD', AO: 'AOA', AR: 'ARS', AT: 'EUR',
    AU: 'AUD', AW: 'AWG', AX: 'EUR', AZ: 'AZN', BA: 'BAM', BB: 'BBD', BD: 'BDT', BE: 'EUR', BF: 'XOF', BG: 'BGN',
    BH: 'BHD', BI: 'BIF', BJ: 'XOF', BL: 'EUR', BM: 'BMD', BN: 'BND', BO: 'BOB', BQ: 'USD', BR: 'BRL', BS: 'BSD',
    BT: 'BTN', BW: 'BWP', BY: 'BYN', BZ: 'BZD', CA: 'CAD', CD: 'CDF', CF: 'XAF', CG: 'XAF', CH: 'CHF', CI: 'XOF',
    CK: 'NZD', CL: 'CLP', CM: 'XAF', CN: 'CNY', CO: 'COP', CR: 'CRC', CV: 'CVE', CW: 'ANG', CY: 'EUR', CZ: 'CZK',
    DE: 'EUR', DJ: 'DJF', DK: 'DKK', DM: 'XCD', DO: 'DOP', DZ: 'DZD', EC: 'USD', EE: 'EUR', EG: 'EGP', ER: 'ERN',
    ES: 'EUR', ET: 'ETB', FI: 'EUR', FJ: 'FJD', FK: 'FKP', FO: 'DKK', FR: 'EUR', GA: 'XAF', GB: 'GBP', GD: 'XCD',
    GE: 'GEL', GF: 'EUR', GG: 'GBP', GH: 'GHS', GI: 'GIP', GL: 'DKK', GM: 'GMD', GN: 'GNF', GP: 'EUR', GQ: 'XAF',
    GR: 'EUR', GT: 'GTQ', GW: 'XOF', GY: 'GYD', HK: 'HKD', HN: 'HNL', HR: 'EUR', HT: 'HTG', HU: 'HUF', ID: 'IDR',
    IE: 'EUR', IL: 'ILS', IM: 'GBP', IN: 'INR', IQ: 'IQD', IS: 'ISK', IT: 'EUR', JE: 'GBP', JM: 'JMD', JO: 'JOD',
    JP: 'JPY', KE: 'KES', KG: 'KGS', KH: 'KHR', KI: 'AUD', KM: 'KMF', KN: 'XCD', KR: 'KRW', KW: 'KWD', KY: 'KYD',
    KZ: 'KZT', LA: 'LAK', LB: 'LBP', LC: 'XCD', LI: 'CHF', LK: 'LKR', LR: 'LRD', LS: 'LSL', LT: 'EUR', LU: 'EUR',
    LV: 'EUR', LY: 'LYD', MA: 'MAD', MC: 'EUR', MD: 'MDL', ME: 'EUR', MF: 'EUR', MG: 'MGA', MK: 'MKD', ML: 'XOF',
    MM: 'MMK', MN: 'MNT', MO: 'MOP', MQ: 'EUR', MR: 'MRU', MS: 'XCD', MT: 'EUR', MU: 'MUR', MV: 'MVR', MW: 'MWK',
    MX: 'MXN', MY: 'MYR', MZ: 'MZN', NA: 'NAD', NC: 'XPF', NE: 'XOF', NG: 'NGN', NI: 'NIO', NL: 'EUR', NO: 'NOK',
    NP: 'NPR', NR: 'AUD', NU: 'NZD', NZ: 'NZD', OM: 'OMR', PA: 'PAB', PE: 'PEN', PF: 'XPF', PG: 'PGK', PH: 'PHP',
    PK: 'PKR', PL: 'PLN', PM: 'EUR', PN: 'NZD', PS: 'ILS', PT: 'EUR', PY: 'PYG', QA: 'QAR', RE: 'EUR', RO: 'RON',
    RS: 'RSD', RU: 'RUB', RW: 'RWF', SA: 'SAR', SB: 'SBD', SC: 'SCR', SD: 'SDG', SE: 'SEK', SG: 'SGD', SH: 'SHP',
    SI: 'EUR', SK: 'EUR', SL: 'SLE', SM: 'EUR', SN: 'XOF', SO: 'SOS', SR: 'SRD', SS: 'SSP', ST: 'STN', SV: 'USD',
    SX: 'ANG', SZ: 'SZL', TC: 'USD', TD: 'XAF', TG: 'XOF', TH: 'THB', TJ: 'TJS', TL: 'USD', TM: 'TMT', TN: 'TND',
    TO: 'TOP', TR: 'TRY', TT: 'TTD', TV: 'AUD', TW: 'TWD', TZ: 'TZS', UA: 'UAH', UG: 'UGX', US: 'USD', UY: 'UYU',
    UZ: 'UZS', VA: 'EUR', VC: 'XCD', VE: 'VES', VG: 'USD', VN: 'VND', VU: 'VUV', WF: 'XPF', WS: 'WST', XK: 'EUR',
    YE: 'YER', YT: 'EUR', ZA: 'ZAR', ZM: 'ZMW', ZW: 'USD'
  };

  const RATES_URL = 'https://open.er-api.com/v6/latest/';
  const CACHE_KEY = 'currency-converter-rates-' + config.shopCurrency;
  const CACHE_TTL = 6 * 60 * 60 * 1000;
  const SKIP_TAGS = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION'];

  const shopCurrency = config.shopCurrency;
  const targetCurrency = COUNTRY_CURRENCY[config.countryCode] || shopCurrency;

  function currencySymbol(currency) {
    try {
      const part = new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' })
        .formatToParts(0)
        .find(p => p.type === 'currency');
      return part ? part.value : currency;
    } catch (e) {
      return currency;
    }
  }

  // Fix the "(INR ₹)" labels in the country selector so each country shows its own currency.
  function updateCountryLabels(root) {
    root.querySelectorAll('[data-cc-country]').forEach(el => {
      const currency = COUNTRY_CURRENCY[el.dataset.ccCountry];
      if (!currency || el.dataset.ccLabelled) return;
      el.dataset.ccLabelled = 'true';
      el.textContent = el.dataset.ccStyle === 'button'
        ? `${currency} ${currencySymbol(currency)}`
        : `${currency} (${currencySymbol(currency)})`;
    });
  }

  updateCountryLabels(document);

  // Market already has its own currency (e.g. a real multi-currency setup later) or no conversion needed.
  if (config.activeCurrency !== shopCurrency || targetCurrency === shopCurrency) {
    new MutationObserver(() => updateCountryLabels(document)).observe(document.documentElement, { childList: true, subtree: true });
    return;
  }

  // Build regexes from the shop's money formats, e.g. "₹{{amount}}" and "₹{{amount}} INR".
  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function decodeFormat(format) {
    const el = document.createElement('div');
    el.innerHTML = format;
    return el.textContent.trim();
  }

  const PLACEHOLDER = /\{\{\s*(amount\w*)\s*\}\}/;
  const formats = [config.moneyWithCurrencyFormat, config.moneyFormat]
    .filter(Boolean)
    .map(decodeFormat)
    .filter(f => PLACEHOLDER.test(f))
    .map(format => {
      const [token, placeholder] = format.match(PLACEHOLDER);
      const [before, after] = format.split(token);
      const pattern = escapeRegex(before).replace(/\s+/g, '\\s*') + '(\\d[\\d.,\'\\s]*\\d|\\d)' + escapeRegex(after).replace(/\s+/g, '\\s*');
      return { regex: new RegExp(pattern, 'g'), placeholder };
    });

  if (!formats.length) return;

  function parseAmount(raw, placeholder) {
    let value = raw.replace(/[\s']/g, '');
    if (placeholder.includes('comma_separator')) {
      value = value.replace(/\./g, '').replace(',', '.');
    } else if (placeholder.includes('space_separator') || placeholder.includes('apostrophe_separator')) {
      value = value.replace(',', '.');
    } else {
      value = value.replace(/,/g, '');
    }
    return parseFloat(value);
  }

  let formatter;
  try {
    formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: targetCurrency, currencyDisplay: 'narrowSymbol' });
  } catch (e) {
    return;
  }

  function format(amount, rate) {
    const converted = formatter.format(amount * rate);
    return config.showCurrencyCode ? `${converted} ${targetCurrency}` : converted;
  }

  function convertTextNode(node, rate) {
    let text = node.nodeValue;
    if (!text || !/\d/.test(text)) return;
    let changed = false;
    for (const { regex, placeholder } of formats) {
      text = text.replace(regex, (match, raw) => {
        const amount = parseAmount(raw, placeholder);
        if (isNaN(amount)) return match;
        changed = true;
        return format(amount, rate);
      });
    }
    if (changed) node.nodeValue = text;
  }

  function shouldSkip(node) {
    const parent = node.parentElement;
    if (!parent) return true;
    if (SKIP_TAGS.includes(parent.tagName)) return true;
    return !!parent.closest('[data-no-convert]');
  }

  function convertTree(root, rate) {
    if (root.nodeType === Node.TEXT_NODE) {
      if (!shouldSkip(root)) convertTextNode(root, rate);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: node => (shouldSkip(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT)
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => convertTextNode(node, rate));
  }

  function showNotes() {
    document.querySelectorAll('[data-currency-converter-note]').forEach(el => {
      el.hidden = false;
    });
  }

  function start(rate) {
    document.documentElement.classList.add('currency-converted');
    convertTree(document.body, rate);
    showNotes();

    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') {
          if (!shouldSkip(mutation.target)) convertTextNode(mutation.target, rate);
        } else {
          mutation.addedNodes.forEach(node => convertTree(node, rate));
        }
      });
      updateCountryLabels(document);
      showNotes();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function readCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.time < CACHE_TTL) return cached.rates;
    } catch (e) {}
    return null;
  }

  function writeCache(rates) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), rates }));
    } catch (e) {}
  }

  const cachedRates = readCache();
  if (cachedRates && cachedRates[targetCurrency]) {
    start(cachedRates[targetCurrency]);
    return;
  }

  fetch(RATES_URL + shopCurrency)
    .then(response => response.json())
    .then(data => {
      if (data.result !== 'success' || !data.rates || !data.rates[targetCurrency]) return;
      writeCache(data.rates);
      start(data.rates[targetCurrency]);
    })
    .catch(() => {});
})();
